import { alpha, useTheme, Typography } from "@mui/material";

import {
  ResponsiveContainer,
  CartesianGrid,
  Tooltip,
  XAxis,
  YAxis,
  Line,
  LineChart,
} from "recharts";
import { CardCore } from "src/Pages/components/CardCore/CardCore";
import { CardBodyCore } from "src/Pages/components/CardCore/Components/CardBodyCore";
import React, { Children } from "react";
import { useContextDashboardContext } from "src/Contexts/Dashboard/ContextDashboardBroker";

interface TooltipProps {
  active?: boolean;
  payload?: Array<{
    payload: {
      value?: number;
      label: string;
    };
    name: string;
    value: number;
  }>;
  labelStyle?: React.CSSProperties;
}

const CustomTooltip: React.FC<TooltipProps> = ({
  active,
  payload,
  labelStyle,
}) => {
  if (!active || !payload || payload.length === 0) {
    return null;
  }

  const data = payload[0].payload;
  return (
    <CardCore>
      <Typography style={labelStyle}>
        {`Data: ${data.label.split("-")[0]} ${
          data.label.split("-")[1] ? `- ${data.label.split("-")[1]}` : ""
        }`}
      </Typography>
      {Children.toArray(
        payload.map((item) => {
          return (
            <Typography>{`${item.name}: ${Number(item.value)}`}</Typography>
          );
        })
      )}
    </CardCore>
  );
};

export const EvolutionLives = () => {
  const { valueProfitDashboard } = useContextDashboardContext();
  if (!valueProfitDashboard) return null;
  const theme = useTheme();

  if (valueProfitDashboard.data.length < 3) {
    valueProfitDashboard.data.unshift({
      label: "",
      value: 0,
    });
  }

  const colorStroke = "#b8b8b8";

  return (
    <CardCore sxStyle={{ margin: "0", height: "100%" }}>
      <CardBodyCore title="Evolução de vidas">
        <ResponsiveContainer height={350} width="100%">
          <LineChart data={valueProfitDashboard.data}>
            <XAxis // barra de baixo
              dataKey="label"
              fontSize={14}
              stroke={colorStroke}
            />

            <YAxis // barra lateral com valores
              fontSize={12}
              stroke={colorStroke}
              tickLine={false}
            />

            <CartesianGrid // grid
              horizontal
              stroke={alpha(colorStroke as string, 0.1)}
              vertical={false}
            />

            <Tooltip
              labelStyle={{ color: colorStroke }}
              content={<CustomTooltip />}
            />

            <Line
              dot
              dataKey="value"
              fill="url(#colorPv)"
              name="Vidas"
              stroke={theme.palette.primary.main}
              strokeWidth={2}
              type="bump"
            />
          </LineChart>
        </ResponsiveContainer>
      </CardBodyCore>
    </CardCore>
  );
};
